import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import audio from './modules/audio'
import category from './modules/category'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    audio,
    category
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer (state, value) {
      state.controls.showDrawer = value
    }
  }
})
